/**
 * In-app browser for owned / off-origin pages (registration, public legal URLs).
 *
 * iOS: SFSafariViewController via @capacitor/browser (App Store guideline 4 —
 * do not dump the user into system Safari to sign in or register).
 * Android: Chrome Custom Tabs. Web: window.open.
 *
 * Search: openInAppBrowser / inAppBrowser — this is the only definition.
 */
import { isNative } from './platform'

function openWithAnchor(url) {
  const link = document.createElement('a')
  link.href = url
  link.target = '_blank'
  link.rel = 'noopener noreferrer'
  document.body.appendChild(link)
  link.click()
  link.remove()
}

/**
 * @param {string} url Absolute http(s) URL.
 * @returns {Promise<void>}
 */
export async function openInAppBrowser(url) {
  if (!url || typeof url !== 'string') return
  if (!isNative()) {
    window.open(url, '_blank', 'noopener,noreferrer')
    return
  }
  try {
    const { Browser } = await import('@capacitor/browser')
    await Browser.open({ url })
  } catch (e) {
    console.warn('[InAppBrowser] Browser.open failed, using fallback:', e?.message || e)
    try {
      window.open(url, '_blank', 'noopener,noreferrer')
    } catch {
      openWithAnchor(url)
    }
  }
}
